import { AccordionButton, AccordionIcon, Box } from "@chakra-ui/react";

const CategoryLabel = ({ category }: { category: string }) => (
  <h2>
    <AccordionButton data-cy={`checklist-category-${category}`} px="0px">
      <Box
        as="span"
        flex="1"
        textAlign="left"
        fontSize="15px"
        fontWeight="600"
      >
        {category}
      </Box>
      <AccordionIcon color="gray.800" w="32px" h="32px" />
    </AccordionButton>
  </h2>
);

export default CategoryLabel;
